import { extractMacroMessageEffects } from './applyMacroActionsToTicketData';
import { isReminderMacro } from './reminderMacro';

/** Mínimo de caracteres antes de sugerir — abaixo disso a sugestão vira ruído. */
const MIN_CHARS = 3;

const normalize = (s) =>
    String(s || '')
        .trim()
        .toLowerCase();

/** Tira pontuação das bordas: "reinstalar," e "(reinstalar" devem casar. */
const limparPalavra = (palavra) => normalize(palavra).replace(/^[^\wÀ-ÿ]+|[^\wÀ-ÿ]+$/g, '');

/**
 * Primeira macro cuja palavra-chave começa com o que foi digitado.
 *
 * A macro do lembrete fica de fora: o texto dela já entra sozinho na abertura do
 * ticket, sugeri-la de novo não faz sentido.
 */
export const findMacroForTypedWord = (macros, palavraDigitada) => {
    const palavra = limparPalavra(palavraDigitada);
    if (palavra.length < MIN_CHARS) return null;
    if (!Array.isArray(macros)) return null;

    return (
        macros.find((macro) => {
            if (!macro || macro.is_enabled === false) return false;
            if (isReminderMacro(macro)) return false;
            const keywords = Array.isArray(macro.keywords) ? macro.keywords : [];
            return keywords.some((k) => {
                const chave = normalize(k);
                return chave.length >= MIN_CHARS && chave.startsWith(palavra);
            });
        }) || null
    );
};

/** Texto da macro em texto puro, para a prévia da confirmação. */
export const getMacroPlainPreview = (macro) => {
    if (!macro) return '';
    const { messageBody } = extractMacroMessageEffects(macro.actions, null);
    return String(messageBody || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
};
